<template>
  <modal name="FlyerShortInfoPopup" transition="pop-out" @closed="hide"
  >
    <div class="requestsDashboardDetail">
      <div
        class="requestsDashboardDetail__inner"
      >
        <div class="requestsDashboardDetail__title">Flyer info</div>
        <div class="requestsDashboardDetail__info" v-if="flyerInfo">
          <div class="requestsDashboardDetail__info-item">
            <div class="requestsDashboardDetail__info-item-title">Id</div>
            <div class="requestsDashboardDetail__info-item-value">{{flyerInfo.flyerId}}</div>
          </div>
          <div class="requestsDashboardDetail__info-item">
            <div class="requestsDashboardDetail__info-item-title">Number</div>
            <div class="requestsDashboardDetail__info-item-value">{{flyerInfo.flyerNumber}}</div>
          </div>
          <div class="requestsDashboardDetail__info-item">
            <div class="requestsDashboardDetail__info-item-title">Name</div>
            <div class="requestsDashboardDetail__info-item-value">{{flyerInfo.flyerName}}</div>
          </div>
          <div class="requestsDashboardDetail__info-item">
            <div class="requestsDashboardDetail__info-item-title">Date of birth</div>
            <div class="requestsDashboardDetail__info-item-value">{{getDisplayDate(flyerInfo.flyerBirthDate)}}</div>
          </div>
          <div class="requestsDashboardDetail__info-item">
            <div class="requestsDashboardDetail__info-item-title">Email</div>
            <div class="requestsDashboardDetail__info-item-value">{{flyerInfo.flyerEmail}}</div>
          </div>
          <div class="requestsDashboardDetail__info-item">
            <div class="requestsDashboardDetail__info-item-title">Mobile</div>
            <div class="requestsDashboardDetail__info-item-value">{{flyerInfo.flyerMobile}}</div>
          </div>
          <div class="requestsDashboardDetail__info-item">
            <div class="requestsDashboardDetail__info-item-title">Address</div>
            <div class="requestsDashboardDetail__info-item-value">{{flyerInfo.flyerAddress}}</div>
          </div>
          <div class="requestsDashboardDetail__info-item">
            <div class="requestsDashboardDetail__info-item-title">Created on</div>
            <div class="requestsDashboardDetail__info-item-value">{{getDisplayDateTime(flyerInfo.flyerCreatedOn)}}</div>
          </div>
        </div>
      </div>

      <button class="fancybox-button fancybox-close-small" @click="hide"></button>
    </div>
  </modal>
</template>

<script>
  import './RequestsDetailPopup.styl'

  export default {
    name: 'FlyerShortInfoPopup',
    props: ['flyerInfo'],
    methods: {
      hide () {
        this.$modal.hide('FlyerShortInfoPopup')
        this.$emit('clearInfo')
      },
      getDisplayDate (dateString) {
        return dateString === null
          ? ''
          : `${new Date(dateString).toLocaleDateString('en-US')}`;
      },
      getDisplayDateTime (dateString) {
        if (!dateString) {
          return ''
        }
        const options = {timeZone: 'America/New_York', hour12: false};
        let date = new Date(dateString);
        date = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        return dateString === null
          ? ''
          : date.toLocaleString('en-US', options);
      },
    },
  }
</script>
